m.connect({
    name: 'langTip',
    countries: {
        ar: ['DZ','BH','TD','KM','DJ','EG','IQ','JO','KW','LB','LY','MR','MA','OM','PS','QA','SA','SO','SOM','SD','SY','TN','AE','YE'],
        es: ['ES','MX','CO','AR','GQ','PE','VE','CL','GT','EC','BO','CU','DO','HN','PY','SV','NI','CR','PA','UY'],
        de: ['DE'],
        fr: ['FR'],
        it: ['IT'],
        pt: ['PT'],
        sv: ['SE'],
        ms: ['MS'],
        th: ['TH'],
    },
    content: {
        p1: {
            ar: 'نحن موجودون بلغتكً',
            es: 'Estamos disponibles en su idioma.',
            de: 'Wir sind in Ihrer Sprache verfügbar.',
            fr: 'Nous sommes disponibles dans votre langage.',
            it: 'Siamo disponibili nella tua lingua.',
            pt: 'Estamos disponíveis no seu idioma.',
            sv: 'Vi finns tillgängliga på ditt språk.',
            ms: 'Kami tersedia dalam bahasa anda.',
            th: 'เราพร้อมให้บริการในภาษาของคุณ',
        },
        p2: {
            ar: 'هل ترغب في التبديل إلى العربية؟',
            es: '¿Le gustaría cambiar al Español?',
            de: 'Möchten Sie auf Deutsch umstellen?',
            fr: 'Voulez-vous changer en Français?',
            it: 'Vuoi cambiarla in Italiano?',
            pt: 'Gostaria de mudar para Português?',
            sv: 'Vill du byta till Svenska?',
            ms: 'Adakah anda ingin bertukar ke Bahasa Melayu?',
            th: 'คุณต้องการเปลี่ยนเป็นภาษา ไทย ไหม',
        },
    },
    button: {
        confirm: {
            ar: 'نعم رجاءً',
            es: 'Sí, gracias',
            de: 'Ja, bitte',
            fr: 'Oui, s\'il vous plaît',
            it: 'Sì, grazie',
            pt: 'Sim, por favor',
            sv: 'Ja tack',
            ms: 'Ya, boleh',
            th: 'ใช่ ช่วยเปลี่ยนให้เลย',
        },
        cancel: {
            ar: 'لا شكرًا',
            es: 'No, gracias',
            de: 'Nein, danke',
            fr: 'Non, merci',
            it: 'No, grazie',
            pt: 'Não, obrigado',
            sv: 'Nej tack',
            ms: 'Tidak, terima kasih',
            th: 'ไม่เป็นไร ขอบคุณ',
        },
    },

    /**
     * Check whether language tip has already closed
     * @return {boolean}
     * */
    get isLangTipClosed() {
        return m.cookie.get('lang_tip') === 'closed';
    },

    /**
     * Create language tip
     * @param  {string} langId - language code
     * @param  {HTMLElement} wrap - wrapped element node
     * */
    createLangTip(langId, wrap) {
        const tip = document.createElement('div');
        tip.className = 'lang-tip';

        const container = document.createElement('div');
        container.className = 'lang-tip__container';

        const header = document.createElement('div');
        header.className = 'lang-tip__header';

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'lang-tip__close';
        close.addEventListener('click', () => this.removeLangTips());

        const content = document.createElement('div');
        content.className = 'lang-tip__content';

        const p1 = document.createElement('p');
        p1.textContent = this.content.p1[langId];

        const p2 = p1.cloneNode(false);
        p2.textContent = this.content.p2[langId];

        const footer = document.createElement('div');
        footer.className = 'lang-tip__footer';

        const confirm = document.createElement('button');
        confirm.type = 'button';
        confirm.className = 'mb-btn mb-btn_small mb-btn_primary';
        confirm.textContent = this.button.confirm[langId];
        confirm.addEventListener('click', () => {
            this.removeLangTips();
            m.cookie.set('lang_id', langId);
            window.location.reload();
        });

        const cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'mb-btn mb-btn_small mb-btn_outline-light';
        cancel.textContent = this.button.cancel[langId];
        cancel.addEventListener('click', () => this.removeLangTips());

        header.append(close);
        content.append(p1, p2);
        footer.append(confirm, cancel);
        container.append(header, content, footer);
        tip.append(container);

        wrap.append(tip);
    },

    /**
     * Load language tips
     * @param  {string} langId - language code
     * */
    loadLangTips(langId) {
        const wrappers = document.querySelectorAll('.lang-tip-wrap');

        setTimeout(() => {
            [...wrappers].forEach(wrap => this.createLangTip(langId, wrap));
        }, 5000);
    },

    /**
     * Remove language tip
     * */
    removeLangTips() {
        const tips = document.querySelectorAll('.lang-tip');

        [...tips].forEach(tip => tip.remove());
        m.cookie.set('lang_tip', 'closed', 1095);
    },

    async init() {
        if (this.isLangTipClosed) {
            return;
        }

        try {
            const response = await fetch(`${m.host.api}/visitor-country?brand_id=CAPITALIX`);

            if (response.ok) {
                const json = await response.json();
                const visitorCountry = json.country.id;

                m.about.allLanguages.forEach(langId => {
                    if (m.about.language !== langId && this.countries[langId]?.includes(visitorCountry)) {
                        this.loadLangTips(langId);
                    }
                });
            }

        } catch (err) {
            console.error(err);
        }
    }
});

m.langTip.init();
